import styled from "styled-components/macro";
import { entityImageStyles } from "../EntityImage/styles";

export const WorldbuildingEntryContainer = styled.div`
  &:focus-visible {
    outline: none;
  }

  ${entityImageStyles}

  .hidden {
    display: none;
  }
  .entry-card {
    background-color: var(--simplified-sb-background);
    border-radius: 20px;
    box-shadow: var(--tiny-drop-shadow-head-on);
    margin: 0px 16px;
    position: relative;
    padding: 10px 14px;
  }

  .selected-entity {
    box-sizing: border-box;
    background: linear-gradient(0deg, var(--selected-card-background) 100%), #fff;
    box-shadow: 0px 0px 10px 0px var(--primary-cta-translucent), 0px 0px 15px 0px var(--primary-cta-translucent);
    box-shadow: inset 0 0 0 2px var(--primary-cta); // inner border that doesn't change card size
  }

  .collapsed-entity {
    /* height: 40px;  */
    /* overflow-y: hidden;  */
    .header {
      margin-bottom: 0px;
    }
  }
  .expanded-entity {
    /* height: auto; */
  }

  .entity-header-left-side-container {
    display: flex;
    min-width: 0;
    align-items: ${(props) => (props.$moveRoleSelector ? "flex-start" : "center")};
    margin-left: -10px;
  }

  .form-container {
    /* overflow-y: hidden; */
    /* transition: height 300ms ease-in-out; */
    .header {
      .title-display {
        div {
          font-size: 18px;
          background: transparent;
          border: 1px solid transparent;
          font-family: "Inter";
          font-weight: 500;
          padding: 0px;
          color: var(--grey-0);
          &:hover {
            .ProseMirror {
              border: 1px solid var(--grey-3);
              box-shadow: var(--tiny-drop-shadow);
            }
          }
          &:focus-within {
            .ProseMirror {
              border: 1px solid var(--primary-cta);
              box-shadow: var(--tiny-drop-shadow);
            }
          }
        }
        .ProseMirror {
          padding: 0px 6px;
          border-radius: 6px;
        }

        // styles the Placeholder text via the Placeholder extension
        .ProseMirror p.is-editor-empty:first-child::before {
          color: var(--grey-1);
          content: attr(data-placeholder);
          float: left;
          height: 0;
          pointer-events: none;
        }

        margin-bottom: 0px;
      }
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: ${(props) => (props.$moveRoleSelector ? "flex-start" : "center")};
      .rotated-chevron {
        transform: rotate(-90deg);
      }
      .entity-header-left-side {
        display: flex;
        min-width: 0;
        align-items: ${(props) => (props.$moveRoleSelector ? "flex-start" : "center")};
        justify-content: flex-start;
        gap: 8px;

        .chevron {
          cursor: pointer;
          width: 20px;
          height: 20px;

          path {
            fill: var(--grey-2);
          }
        }

        .grabber-container,
        .grabber {
          svg {
            cursor: grab;
            padding: 0px;
            flex-shrink: 0;
            margin: 0px;
            overflow-clip-margin: content-box;
            width: 24px;
            height: 24px;
          }
        }

        .entry-name {
          .tip-tap-field-container {
            .ProseMirror {
              color: var(--grey-0);
            }
          }
        }
      }

      .entity-header-right-side {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: 0px;
      }

      > .item-menu {
        flex-shrink: 0;
      }
      .dropdown {
        margin-bottom: 0px;
      }

      .role-selector {
        width: 150px;

        .css-1hb7zxy-IndicatorsContainer svg {
          width: 16px;
          height: 16px;
          path {
            fill: var(--grey-2);
          }
        }

        .css-11pbfca-singleValue {
          & > div:first-child {
            display: block !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      // for when the center column is at its smallest width
      &.small-width {
        .css-9p6sgq-menu {
          width: 150px;
        }
      }

      // simplified-only helpers
      .chevron-container,
      .grabber-container {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .grabber-container {
        margin-top: -2px; // visually align with the chevron

        svg {
          cursor: pointer;
          width: 20px;
          height: 20px;
          circle {
            fill: var(--grey-2);
          }
          flex-shrink: 0;
        }
      }

      .entity-header-left-side {
        display: flex;
        align-items: ${(props) => (props.$moveRoleSelector ? "flex-start" : "center")};
        gap: 8px;
      }

      .name-and-role {
        display: flex;
        min-width: 0;
        align-items: center;
        gap: 10px;
      }
      &.small-width {
        .name-and-role {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
    .small-field-row {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      gap: 18px;
      .key {
        margin-bottom: 3px;
      }
      .field {
        width: 100%;
        .tip-tap-field-container > div {
          width: calc(100% - 20px);
          border-radius: 8px;
          padding: 9px 7px;
          font-size: 16px;
          font-family: "Inter";
          border: 1px solid var(--grey-3);
          background-color: var(--document-background);
          color: var(--grey-0);
          box-shadow: var(--tiny-drop-shadow);
          &:focus-within {
            border: 1px solid var(--primary-cta);
          }
        }
      }
    }

    .tiptap-fields {
      position: relative;
      z-index: 1;
      &.flat {
        z-index: unset;
      }
      .custom-field-header {
        display: flex;
        align-items: flex-end;

        input {
          font-weight: 500;
          font-family: "Inter";
          padding: 0px;
          margin: 0px;
        }

        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 500;
        color: var(--grey-1);
      }
    }
  }
  .field {
    margin-bottom: 3px;
    .key {
      margin: 0px;
      padding: 2px 0px;
      font-size: 16px;
      font-weight: 500;
      color: var(--grey-1);
    }
  }

  .entity-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .project-title {
      font-family: "Inter";
      margin-top: 9px;
      font-size: 14px;
      color: var(--grey-1);
      font-weight: 500;
    }
  }

  .error {
    background: var(--danger-color);
    color: var(--cta-text-color);
    padding: 10px;
    border-radius: 8px;
    font-size: 16px;
    font-family: "Inter";
    font-weight: 500;
  }
  .read-only {
    .header {
      .entity-header-left-side {
        margin-left: -8px;
        pointer-events: none;
      }
    }
  }
`;
